// extracted by mini-css-extract-plugin
module.exports = {"root":"Param_root__1EC4d","valueCheck":"Param_valueCheck__1bFFq","valueCross":"Param_valueCross__2bZv7"};